/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Deck_Submission_OptionalInputs */



/**
* | output |
* | --- |
* | "Decklist optional" |
*
* @param {Tournaments_Lib_Deck_Submission_OptionalInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_deck_submission_optional = /** @type {((inputs?: Tournaments_Lib_Deck_Submission_OptionalInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Deck_Submission_OptionalInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deckliste optional")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decklist facultative")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("卡组表可选")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("牌組清單選填")
	if (locale === "ko") return /** @type {LocalizedString} */ ("덱 목록 선택")
	return /** @type {LocalizedString} */ ("Decklist optional")
});